export default "__VITE_ASSET__BxNnpKiC__"